import React from 'react';
export default function DiButton(props) {
    return React.createElement(
        'div',
        { className: 'icon btn ' + props.className, onClick: props.onClick },
        React.createElement(
            'span',
            { className: 'noicon' },
            props.text
        )
    );
}